import { Component, ViewChild, ElementRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort'
import { LightingDataService } from './services/lighting-data.service'
import { Form, FormGroup, FormGroupDirective, FormArray, FormControl, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse, HttpRequest } from "@angular/common/http";
import { HttpService } from "./services/http.service";
import moment, { Moment } from "moment";
import { default as _rollupMoment } from "moment";
import { SubmitAlertComponent } from './submitAlert/submitAlert.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as XLSX from 'xlsx-js-style';


export interface Item {
  partNumber: string;
  description: string;
}
export interface RowData {
  partName: string;
  partNumber: string;
  qty: number;
  notes: string;
}
const ELEMENT_DATA: RowData[] = [];
declare const Buffer;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  @ViewChild(FormGroupDirective) formRef: FormGroupDirective;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public subscribeForm: FormGroup;
  public email: FormControl;
  public recaptcha: FormControl;
  durationInSeconds = 5;
  private unsubscribe = new Subject<void>();
  token: string | undefined;
  value1: string = '';
  rowId = 0;
  captchaVerified:Boolean = false;
  displayedColumns: string[] = ['partNumber', 'partName', 'qty', 'notes', 'actions'];
  myformArray = new FormArray([]);
  dataSource = ELEMENT_DATA;
  personalDetails = ELEMENT_DATA;
  minDate: Date;
  //Controls for item table
  stateCtrl = new FormControl("");
  qtyCtrl = new FormControl("");
  notesCtrl = new FormControl("");
  floatLabelControl = new FormControl('never');

  filteredItems: Observable<Item[]>;
  items: Item[] = this.lightingDataService.getItems();

  //Controls for personal data
  date = new FormControl(new Date());
  returnDateCtrl = new FormControl(new Date());
  inventoryCtrl = new FormControl("");
  pullDateCtrl = new FormControl(Date);
  locationCtrl = new FormControl("");
  commentCtrl = new FormControl("");
  rentalStartCtrl = new FormControl(Date);
  rentalReturnCtrl = new FormControl(Date);
  requestorCtrl = new FormControl("");
  phoneCtrl = new FormControl("");
  lengthCtrl = new FormControl("");
  deliveryCtrl = new FormControl("");
  showCtrl = new FormControl("");
  pickupDateCtrl = new FormControl(Date);
  pickupTime = new FormControl("");
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email
  ]);
  nameFormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(4)
  ]);
  register() {
    let user = {
      name: this.nameFormControl.value,
      email: this.emailFormControl.value,
      return: moment(this.returnDateCtrl.value).format("MM/DD/YYYY"),
      dateOrdered: moment(this.date.value).format("MM/DD/YYYY"),
      pullDate: moment(this.pullDateCtrl.value).format("MM/DD/YYYY"),
      location: this.locationCtrl.value,
      comment: this.commentCtrl.value,
      order: this.dataSource,
      rentalStart: moment(this.rentalStartCtrl.value).format("MM/DD/YYYY"),
      rentalEnd: moment(this.rentalReturnCtrl.value).format("MM/DD/YYYY"),
      requestor: this.requestorCtrl.value,
      phone: this.phoneCtrl.value,
      duration: this.lengthCtrl.value,
      show: this.showCtrl.value,
      delivery: this.deliveryCtrl.value,
      deliveryDate: moment(this.pickupDateCtrl.value).format("MM/DD/YYYY"),
      deliveryTime: this.pickupTime.value
    }

    this.exportExcel(user);

  }

  @ViewChild(MatTable, { static: false }) table: MatTable<any>;

  constructor(public Http: HttpService, public dialog: MatDialog, private lightingDataService: LightingDataService, private http: HttpClient, private _snackBar: MatSnackBar) {
    this.filteredItems = this.stateCtrl.valueChanges
      .pipe(
        startWith(''),
        map(item => item ? this._filterStates(item) : this.items.slice())
      );
  }

  ngOnInit() {
    this.createFormControls();
    this.createForm();
    this.minDate = new Date();
  }

  onCaptchaResolved(token: string | null): void {
    if (token) {
      console.log(this.captchaVerified)
      this.verifyCaptcha(token);
    }
  }


  createFormControls() {
    this.email = new FormControl('', [
      Validators.required
    ]);
  }

  createForm() {
    this.subscribeForm = new FormGroup({
      emailFormControl: this.emailFormControl,
      date: this.date,
      returnDateCtrl: this.returnDateCtrl,
      pullDateCtrl: this.pullDateCtrl,
      locationCtrl: this.locationCtrl,
      commentCtrl: this.commentCtrl,
      rentalStartCtrl: this.rentalStartCtrl,
      rentalEndCtrl: this.rentalReturnCtrl,
      requestorCtrl: this.requestorCtrl,
      phoneCtrl: this.phoneCtrl,
      lengthCtrl: this.lengthCtrl,
      showCtrl: this.showCtrl,
      deliveryCtrl: this.deliveryCtrl,
      pickupDateCtrl: this.pickupDateCtrl,
      pickupTime: this.pickupTime

    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  add() {
    if (this.stateCtrl.value) {
      var fullPart = this.stateCtrl.value;
      var partSplit = fullPart.split("|");
      var partNumber = partSplit[0];
      var partName = partSplit[1];
      this.rowId = this.rowId + 1;
      this.dataSource.push({
        partNumber: partNumber,
        qty: 1,
        partName: partName,
        notes: ""
      });

      this.stateCtrl.setValue("");
      if (this.table) {
        this.table.renderRows();
      }

    }
  }
  private _filterStates(value: string): Item[] {
    const filterValue = value.toLowerCase();

    return this.items.filter(item => String(item.partNumber).toLowerCase().indexOf(filterValue) > -1 ||
      item.description.toLowerCase().indexOf(filterValue) > -1);
  }

  remove(index: number) {
    this.dataSource.splice(index, 1);
    this.table.renderRows();
  }


  exportExcel(user) {
    const workSheet = XLSX.utils.json_to_sheet([[]]);
    XLSX.utils.sheet_add_aoa(workSheet, [["Date: " + user.dateOrdered], ["Pull Date: " + user.pullDate],
    ["Rental Starts: " + user.rentalStart], ["Rental Ends: " + user.rentalEnd], ["Length of Rental: " + user.duration],
    ["Show Name: " + user.show], ["Comments: " + user.comment], [" "],], { origin: 'C1' });
    XLSX.utils.sheet_add_aoa(workSheet, [["Location: " + user.location], ["Ordered By: " + user.requestor],
    ["Phone: " + user.phone], ["Email: " + user.email], ["Delivery/Pickup: " + user.delivery],
    ["Delivery/Pickup Date: " + moment(this.pickupDateCtrl.value).format("MM/DD/YYYY")],
    ["Delivery/Pickup Time : " + user.deliveryTime]], { origin: 'D1' });
    //add header for order table
    let Heading = [['Part #', 'Qty', 'Description', 'Notes']];
    XLSX.utils.sheet_add_aoa(workSheet, Heading, { origin: 'A10' });
    //add order table
    XLSX.utils.sheet_add_json(workSheet, user.order, { origin: -1, skipHeader: true });
    //set column widths
    var wscols = [
      { wch: 12.5, },
      { wch: 5.5 },
      { wch: 30.25 },
      { wch: 30.25 }
    ];
    workSheet['!cols'] = wscols;
    //make all columns wrap if text is too long
    for (var i in workSheet) {
      if (typeof workSheet[i] != 'object') continue;
      workSheet[i].s = {
        alignment: {
          wrapText: '1',
        }
      }
      var rowIndex = 9;
      for (var j = 0; j <= this.dataSource.length; j++) {
        rowIndex = rowIndex + 1;
        var cell = ("B" + rowIndex)
        workSheet[cell].s = {
          alignment: {
            horizontal: 'center',
          }
        }

      }
    }
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Invoice');
    const report = XLSX.write(workBook, { type: 'base64', compression: true });
    user.order = report;
    this.sendEmail(user);

  }
  public verifyCaptcha(key){
    const apiURL = 'https://7fvfb18xr9.execute-api.us-west-2.amazonaws.com/dev/getRecaptcha';
    let body = {
      key: key
    }
    const httpOptions: { headers; observe } = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      observe: "response",
    };
       const promise = new Promise((resolve, reject) => {
      this.http
        .post(apiURL, body, httpOptions)
        .toPromise()
        .then(
          (success: HttpResponse<any>) => {
        console.log("verified, can move to submit")
            // success
                  console.log(this.captchaVerified)
            this.captchaVerified = true;
                  console.log(this.captchaVerified)
            resolve();
          },
          (err) => {
            // error
            reject(err);
          }
        );
    });
    return promise;
  };


  public sendEmail(emailInfo) {
    const apiURL = 'https://7fvfb18xr9.execute-api.us-west-2.amazonaws.com/dev/sendEmailGrip';
    //https://d13y175uszgr5d.cloudfront.net/dev/sendEmailGrip

    const httpOptions: { headers; observe } = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      observe: "response",
    };
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(apiURL, emailInfo, httpOptions)
        .toPromise()
        .then(
          (success: HttpResponse<any>) => {
            this.dataSource = [];
            this._snackBar.openFromComponent(SubmitAlertComponent, {
              duration: this.durationInSeconds * 1000,
            });
            this.subscribeForm.reset();
            this.formRef.resetForm();
            this.captchaVerified = false;
            window.location.reload();
            // success
            resolve();
          },
          (err) => {
            // error
            reject(err);
          }
        );
    });
    return promise;
  }
}
